import jsPDF from 'jspdf';
import { useRoute } from 'vue-router';

// 处理打印
export const handlePrint = async (
  images: string[], 
  exportToPdf: boolean = false,
  orientation: 'portrait' | 'landscape' = 'landscape',
  fileName: string = '图纸导出'
) => {
  console.log('print.ts - handlePrint start', {
    imageCount: images.length,
    exportToPdf,
    orientation
  });

  if (images.length === 0) {
    alert('没有可打印的图纸')
    return
  }

  // 获取token
  const token = localStorage.getItem('token')
  if (!token) {
    alert('未登录')
    return
  }

  if (exportToPdf) {
    try {
      console.log('print.ts - 开始创建PDF');
      // 直接创建PDF
      const pdf = new jsPDF(orientation, 'mm', 'a4');
      
      // 加载所有图片
      const loadImage = (url: string): Promise<HTMLImageElement> => {
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = 'anonymous';
          img.onload = () => {
            console.log('print.ts - 图片加载成功:', url);
            resolve(img);
          };
          img.onerror = (error) => {
            console.error('print.ts - 图片加载失败:', url, error);
            reject(new Error('图片加载失败'));
          };
          const fullUrl = url.includes('?') ? `${url}&token=${token}` : `${url}?token=${token}`;
          console.log('print.ts - 开始加载图片:', fullUrl);
          img.src = fullUrl;
        });
      };

      console.log('print.ts - 开始加载所有图片');
      // 等待所有图片加载完成
      const loadedImages = await Promise.all(
        images.map(url => loadImage(url).catch(error => {
          console.error('print.ts - 图片加载错误:', error);
          return null;
        }))
      );

      // 过滤掉加载失败的图片
      const validImages = loadedImages.filter((img): img is HTMLImageElement => img !== null);
      console.log('print.ts - 成功加载的图片数量:', validImages.length);

      if (validImages.length === 0) {
        alert('所有图片加载失败');
        return;
      }

      // 添加图片到PDF
      validImages.forEach((img, index) => {
        if (index > 0) {
          pdf.addPage();
        }

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const imgRatio = img.width / img.height;
        const pageRatio = pageWidth / pageHeight;
        
        let imgWidth, imgHeight;
        
        // 计算图片尺寸，确保完全适应页面
        if (imgRatio > pageRatio) {
          // 图片比页面更宽，以宽度为基准
          imgWidth = pageWidth;
          imgHeight = pageWidth / imgRatio;
        } else {
          // 图片比页面更高，以高度为基准
          imgHeight = pageHeight;
          imgWidth = pageHeight * imgRatio;
        }

        // 如果计算出的尺寸超出页面，进行缩小
        if (imgWidth > pageWidth) {
          const scale = pageWidth / imgWidth;
          imgWidth *= scale;
          imgHeight *= scale;
        }
        if (imgHeight > pageHeight) {
          const scale = pageHeight / imgHeight;
          imgWidth *= scale;
          imgHeight *= scale;
        }
        
        // 计算居中位置
        const x = (pageWidth - imgWidth) / 2;
        const y = (pageHeight - imgHeight) / 2;

        console.log('print.ts - 添加图片到PDF:', {
          index,
          pageWidth,
          pageHeight,
          imgWidth,
          imgHeight,
          imgRatio,
          x,
          y
        });

        pdf.addImage(img, 'JPEG', x, y, imgWidth, imgHeight);
      });

      console.log('print.ts - 开始保存PDF');
      // 保存PDF
      pdf.save(`${fileName}.pdf`);
      console.log('print.ts - PDF保存完成，文件名：', fileName);
    } catch (error) {
      console.error('print.ts - PDF导出失败:', error);
      alert('PDF导出失败，请重试');
    }
    return;
  }

  // 以下是打印功能
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  document.body.appendChild(iframe)
  
  const doc = iframe.contentWindow?.document
  if (!doc) {
    alert('创建打印区域失败')
    return
  }

  doc.open()
  doc.write('<!DOCTYPE html>')
  doc.write('<html>')
  doc.write('<head>')
  doc.write('<meta charset="utf-8">')
  doc.write('<style>')
  doc.write('body { margin: 0; padding: 0; }')
  doc.write('.print-container { display: flex; flex-direction: column; }')
  doc.write('.print-item { break-after: page; height: 100vh; display: flex; align-items: center; justify-content: center; }')
  doc.write('.print-item:last-child { break-after: auto; }')
  doc.write('img { max-width: 100%; max-height: 100vh; object-fit: contain; }')
  doc.write('@media print { .print-item { height: 100vh; } }')
  doc.write('</style>')
  doc.write('</head>')
  doc.write('<body>')
  doc.write('<div class="print-container">')
  
  // 添加token到图片请求中
  images.forEach(image => {
    const fullUrl = image.includes('?') 
      ? `${image}&token=${token}`
      : `${image}?token=${token}`
    doc.write(`<div class="print-item"><img src="${fullUrl}" crossorigin="anonymous" onerror="this.parentElement.innerHTML=''" /></div>`)
  })
  
  doc.write('</div>')
  doc.write('<script>')
  doc.write(`
    window.onload = () => {
      const images = document.querySelectorAll('img');
      let loadedImages = 0;
      let failedImages = 0;
      const totalImages = images.length;

      const checkAllImagesLoaded = () => {
        if (loadedImages + failedImages === totalImages) {
          if (failedImages === totalImages) {
            alert('所有图片加载失败');
          } else {
            window.print();
          }
          // 清理iframe
          setTimeout(() => {
            document.body.removeChild(window.frameElement);
          }, 1000);
        }
      };

      images.forEach(img => {
        if (img.complete) {
          if (img.naturalHeight === 0) {
            failedImages++;
          } else {
            loadedImages++;
          }
          checkAllImagesLoaded();
        } else {
          img.onload = () => {
            loadedImages++;
            checkAllImagesLoaded();
          };
          img.onerror = () => {
            failedImages++;
            img.parentElement.innerHTML = '图片加载失败';
            checkAllImagesLoaded();
          };
        }
      });

      // 设置超时检查
      setTimeout(() => {
        if (loadedImages + failedImages < totalImages) {
          alert('部分图片加载超时');
          window.print();
          // 清理iframe
          setTimeout(() => {
            document.body.removeChild(window.frameElement);
          }, 1000);
        }
      }, 10000); // 10秒超时
    };
  `)
  doc.write('</script>')
  doc.write('</body>')
  doc.write('</html>')
  doc.close()
}
